"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCreateTicketSequenceForCatalog = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const graphql_1 = require("../../../../__generated__/graphql");
const constants_1 = require("./constants");
const tags_utils_1 = require("../../tags/tags.utils");
const create_ticket_sequence_mutation_1 = require("../create-ticket-sequence.mutation");
const useCreateTicketSequenceForCatalog = () => {
    const [createTicketSequenceMutation, data] = (0, react_2.useMutation)(create_ticket_sequence_mutation_1.CREATE_TICKET_SEQUENCE);
    const createTicketSequenceForCatalog = (0, react_1.useCallback)((_a) => __awaiter(void 0, void 0, void 0, function* () {
        var { catalogId, tags, tickets, options: extraOptions, variables } = _a, mutationOptions = __rest(_a, ["catalogId", "tags", "tickets", "options", "variables"]);
        const { additionalLinks = [], readUrl } = extraOptions !== null && extraOptions !== void 0 ? extraOptions : {};
        const tagOptions = (tags === null || tags === void 0 ? void 0 : tags.length) ? ` Options: ${(0, tags_utils_1.stringifyTags)(tags)}` : '';
        const links = [{ reference: catalogId, linkType: graphql_1.LinkType.Mention }, ...additionalLinks];
        const ticketInputs = tickets.map((ticketType) => {
            if (ticketType === constants_1.TicketType.Extract && tagOptions) {
                return Object.assign(Object.assign({}, constants_1.ticketTypeToContentMap[constants_1.TicketType.Extract]), { description: `${constants_1.ticketTypeToContentMap[constants_1.TicketType.Extract].description}${tagOptions}`, links });
            }
            if (ticketType === constants_1.TicketType.CatalogImport && readUrl) {
                return Object.assign(Object.assign({}, constants_1.ticketTypeToContentMap[constants_1.TicketType.CatalogImport]), { description: `${constants_1.CATALOG_IMPORT_FROM_URL_TICKET_DESCRIPTION}${readUrl}`, links });
            }
            return Object.assign(Object.assign({}, constants_1.ticketTypeToContentMap[ticketType]), { links });
        });
        return createTicketSequenceMutation(Object.assign(Object.assign({}, mutationOptions), { variables: Object.assign(Object.assign({}, variables), { tickets: ticketInputs }) }));
    }), [createTicketSequenceMutation]);
    return Object.assign({ createTicketSequenceForCatalog }, data);
};
exports.useCreateTicketSequenceForCatalog = useCreateTicketSequenceForCatalog;
exports.default = exports.useCreateTicketSequenceForCatalog;
